import { locales } from 'constants/index';

import { IError } from 'types';

const UNAUTHORIZED_MESSAGE = 'You are not authorized to perform this action.';

/*
 * Whatever comes back from here is handed to a Toast as a child, so it has to
 * be a string: rendering an object throws, and with no error boundary above the
 * pages that unmounts the whole app and leaves a blank screen. Error bodies are
 * not consistent — some handlers send { message }, others { error }, and some
 * put a raw driver error object in there — so every branch is narrowed to text.
 */
function toMessage(value: unknown): string {
  if (typeof value === 'string') return value.trim();

  if (value && typeof value === 'object') {
    const { sqlMessage, message } = value as Record<string, unknown>;

    if (typeof sqlMessage === 'string' && sqlMessage.trim()) return sqlMessage;
    if (typeof message === 'string' && message.trim()) return message;
  }

  return '';
}

const useExtractServerError = () => {
  const extractErrorMessage = (errorObject: unknown): string => {
    // There is no response at all when the request never reached the server
    // (network error, CORS, timeout), so nothing below may assume one.
    const response = (errorObject as IError | undefined)?.response;

    if (response?.status === 401 || response?.status === 403) {
      return UNAUTHORIZED_MESSAGE;
    }

    return (
      toMessage(response?.data?.message) ||
      toMessage(response?.data?.error) ||
      locales.errors.title
    );
  };

  return { extractErrorMessage };
};

export default useExtractServerError;
